export default {
  en: {
    menu: {
      home: {
        text: "Home",
        title: "Home",
      },
      markets: {
        text: "Markets",
        title: "Markets",
      },
      mediaLibrary: {
        text: "Media Library",
        title: "Media Library",
      },
      help: {
        text: "Help",
        title: "Online help",
      },
      contact: {
        text: "Contact",
        title: "Contact us",
      }
    },
    window: {
      error: {
        login: {
          title: "Login Error",
          content: "A problem occurred during your authentication, check your connection information."
        },
        disconnect: {
          title: "Under maintenance",
          content: "The documentation service is currently under maintenance, try again later."
        }
      }
    },
    footer: {
      col: {
        title: "Navigation",
        title2: "Other websites",
        title3: "Keep in touch",
      },
      copyright: {
        line1: "Water-powered proportional dosing pumps manufacturer since 1974. DOSATRON provides you with quality fluid handling equipment, service excellence, a high level of expertise, and customer proximity all over the world.",
        line2: "Copyright © {0} DOSATRON. All rights reserved.",
      },
    },
    filters: {
      languages: "Active language | Active languages",
      markets: "Active market | Active markets",
      sectors: "Active sector | Active sectors",
    },
    page: {
      search: {
        title: "Results for \"<strong>{0}</strong>\"",
        overline: "No document | Number of document: <strong>{0}</strong> | Number of documents: <strong>{0}</strong>",
        message: {
          noresult: "No document for <strong>{0}</strong>."
        }
      },
      markets: {
        title: "Our markets",
        overline: "Discover all of our available documents by markets",
        message: {
          noresult: "No document for <strong>{0}</strong> market."
        }
      },
      sectors: {
        title: "Our sectors",
        overline: "Discover all of our available documents by sectors",
        message: {
          noresult: "No document for <strong>{0}</strong> sector."
        }
      },
      pump: {
        message: {
          noresult: "No document for pump <strong>{0}</strong>."
        }
      },
      mediaLibrary: {
        title: "Corporate media library",
        overline: "Download the Dosatron logo, usage guidelines and ours certificates",
        message: {
          noresult: "No document"
        }
      },
      contact: {
        title: "Contact",
        overline: "",
        content: "<p>You want to ask us a specific question, receive a document, subscribe to the Dosatron Newsletter, thank you for please completing the following form.<br/>We will come-back to you as soon as possible.</p><p><a href=\"https://www.dosatron.com/en/contact-support/contact\" target=\"_blank\" class=\"v-btn v-btn--tile theme--light elevation-0 v-size--large primary my-4\" title=\"Contact form DOSATRON (new window)\">Utiliser le formulaire de contact</a></p>"
      },
      help: {
        title: "Help",
        overline: "Identification of the model number",
        content: "<h2>How does the search by dosing unit reference work?</h2><p>We need the first three characters of your serial number to give you an answer.</p><h2>Where can I find my dosatron reference?</h2><p>The model number is engraved on the side of your product or on the service label, which is usually found on the underside of the product and looks like this.</p><div class=\"row\"><div class=\"col-sm-12 col-12\"><img alt=\"\" src=\"/assets/D30WL30000NIEAF.png\" class=\"img-fluid\" /></div></div><h2>How to check this reference?</h2><ul><li>On the user&#39;s manual and the original packaging.</li><li>On the product label.</li></ul><p>Here are some examples of correct model names: <strong>D25RE09AF</strong>, <strong>D30GL02BPVF</strong> and <strong>D07RE125AF</strong>.</p><h2>How do I understand my dosatron reference number?</h2><p>The reference for your dosatron may look like a string of randomly chosen letters and numbers, yet it follows a certain logic.</p><p>Each model name can contain up to 5 segments that can help you identify important information about your Dosatron.</p><p>These 5 parts are :</p><ul><li>The type of Dosatron -- ex. D / DIA / SD</li><li>The dosage (% or ratio) -- ex. 07 / 25 / 3 / 8 / 9 / 20</li><li>If the dosing is adjustable or Fixed -- ex. RE / F or If the model is part of a line -- ex. AL / GL / WL / IL</li><li>The type of seals present in the model -- ex. AF / VF / K</li><li>Another extension (internal to Dosatron)</li></ul>"
      },
    },
    btn: {
      watch: "Watch",
      watchVideo: "Watch video",
      cancel: "Cancel",
      login: "Login",
      download: "Download",
      detail: "Detail",
      allDocuments: "All documents"
    },
    theme: {
      al: "Animal Health",
      gl: "Irrigation",
      wl: "Water Treatment",
      fl: "Food & Hygiene",
      il: "Industry",
      searchFilters: "Search filters",
      sectors: "Sectors",
      search: "Search",
      notClassified: "Not classified",
      filterLanguages: "Languages filter",
      filterMarkets: "Markets filter",
      filterSectors: "Sectors filter",
      orientation: "Orientation",
      definition: "Resolution",
      difficuly: "Difficulty",
      viewCount: "Number of views",
      colorMode: "ColorMode",
      colorSpace: "ColorSpace",
      resolutionUnit: "Unit",
      resolution: "Resolution",
      dimensions: "Dimensions",
      other: "other",
      others: "{n} other | {n} others",
      distributor: "distributor",
      size: "Size",
      date: "Date",
      duration: "Duration",
      documents: "documents",
      document: "document",
      documentCount: "no document | {n} document | {n} documents",
      meta: "Information | Informations",
      pageCount: "no page | {n} page | {n} pages",
      pageCountLabel: "Number of pages",
      availableLanguage: "Available language | Available languages",
      availableMarket: "Market Available | Markets Available",
      availableSector: "Sector Available | Sectors Available",
      availablePack: "Pack Available | Packs Available",
      login: {
        username: "Username",
        password: "Password"
      }
    },
    account: {
      profil: "Account",
      logout: "Logout"
    },
    field: {
      required: "Field is required",
      mailRequired: "E-mail is required",
      mailValid: "E-mail must be valid",
    },
    user: {
      login: "Login",
      uid: "ID",
      fullname: "Fullname",
      company: "Company",
      mail: "Mail",
      roles: "Roles",
      language: "Language",
      status: "Status",
      active: "Active account",
    },
    headband: {
      search: {
        search: "Search",
        placeholder: "Search for a dosing pump reference or keyword‎…",
        helpText: "Where can I find my Dosatron’s reference",
        moreFilters: "More filters",
      },
      newsletter: {
        title: "Subscribe to our newsletter",
        overline: "Receive updates and latest news direct from our team. Simply enter yout mail.",
        placeholder: "Enter an valid email address",
        messages: {
          success: "Your email address has been saved",
          error: "An error has occurred",
        },
      }
    },
    follow: {
      facebook: "Follow Dosatron on Facebook (new window)",
      linkedin: "Follow Dosatron on Linkedin (new window)",
      youtube: "Suscribe Dosatron Channel on Youtube (new window)",
      instagram: "Follow Dosatron on Instagram (new window)",
    }
  },
  fr: {
    menu: {
      home: {
        text: "Accueil",
        title: "Accueil",
      },
      markets: {
        text: "Marchés",
        title: "Marchés",
      },
      mediaLibrary: {
        text: "Médiathèque",
        title: "Médiathèque",
      },
      help: {
        text: "Aide",
        title: "Aide en ligne",
      },
      contact: {
        text: "Contact",
        title: "Nous contacter",
      }
    },
    window: {
      error: {
        login: {
          title: "Erreur de connexon",
          content: "Un problème est survenu lors de votre authentification, vérifiez vos informations de connexion."
        },
        disconnect: {
          title: "En maintenance",
          content: "Le service de documentation est actuellement en maintenance, réessayer plus tard."
        }
      }
    },
    footer: {
      col: {
        title: "Navigation",
        title2: "Nos autres sites web",
        title3: "Gardons le contact",
      },
      copyright: {
        line1: "Fabricant de pompes doseuses proportionnelles sans électricité depuis 1974. DOSATRON vous fournit des équipements de qualité dans le traitement des fluides, l’excellence dans le service, un haut niveau d’expertise, et la proximité clients partout dans le monde.",
        line2: "Copyright © {0} DOSATRON. Tous droits réservés."
      },
    },
    filters: {
      languages: "Langue filtrée | Langues filtrées",
      markets: "Marché filtrée | Marchés filtrés",
      sectors: "Secteur filtrée | Secteurs filtrés",
    },
    page: {
      search: {
        title: "Résultats pour \"<strong>{0}</strong>\"",
        overline: "Aucun document | Nombre de document: <strong>{0}</strong> | Nombre de documents: <strong>{0}</strong>",
        message: {
          noresult: "Aucun document pour la recherche <strong>{0}</strong>."
        }
      },
      markets: {
        title: "Nos marchés",
        overline: "Découvrez l'ensemble de nos documents téléchargeables par marchés",
        message: {
          noresult: "Aucun document pour le marché <strong>{0}</strong>."
        }
      },
      sectors: {
        title: "Nos secteurs",
        overline: "Découvrez l'ensemble de nos documents téléchargeables par secteurs",
        message: {
          noresult: "Aucun document pour le secteur <strong>{0}</strong>."
        }
      },
      pump: {
        message: {
          noresult: "Aucun document pour le doseur <strong>{0}</strong>."
        }
      },
      mediaLibrary: {
        title: "Médiathèque institutionnelle",
        overline: "Téléchargez le logo Dosatron, les directives d'utilisation et nos certificats",
        message: {
          noresult: "Aucun document."
        }
      },
      contact: {
        title: "Contact",
        overline: "",
        content: "<p>Vous souhaitez nous contacter avec une question spécifique, accéder à une documentation, merci de bien vouloir compléter le formulaire ci-dessous, nous ne manquerons pas de revenir vers vous.</p><p><a href=\"https://www.dosatron.com/fr/contact-support/contact\" target=\"_blank\" class=\"v-btn v-btn--tile theme--light elevation-0 v-size--large primary my-4\" title=\"Formulaire de contact DOSATRON (nouvelle fenêtre)\">Utiliser le formulaire de contact</a></p>"
      },
      help: {
        title: "Aide en ligne",
        overline: "Identification de la référence du modèle",
        content: "<h2>Comment fonctionne la recherche par référence de doseur?</h2><p>Nous avons besoin des trois premiers caractères de votre numéro de série pour vous proposer une réponse.</p><h2>Où trouver la référence de mon Dosatron?</h2><p>La référence du modèle est gravée sur le côté de votre produit ou sur l&#39;étiquette de service, laquelle se trouve généralement sur la face inférieure du produit et qui ressemble à ceci.</p><div class=\"row\"><div class=\"col-sm-12 col-12\"><img alt=\"\" src=\"/assets/D30WL30000NIEAF.png\" class=\"img-fluid\" /></div></div><h2>Comment vérifier cette référence?</h2><ul><li>Sur le manuel d&#39;utilisation et l&#39;emballage d&#39;origine de doseur.</li><li>Sur l&#39;étiquette du produit.</li></ul><p>Voici quelques exemples de noms de modèle corrects : <strong>D25RE09AF</strong>,<strong> D30GL02BPVF</strong> et <strong>D07RE125AF</strong>.</p><h2>Comment comprendre la référence de mon Dosatron?</h2><p>La référence de votre Dosatron peut avoir l&#39;air d&#39;une suite de lettres et de nombres choisis au hasard, pourtant il suit une certaine logique.</p><p>Chaque nom de modèle peut contenir jusqu&#39;à 5 segments qui peuvent vous aider à identifier des informations importantes à propos de votre Dosatron.</p><p>Ces 5 parties sont :</p><ul><li>Le type de Dosatron -- ex. D / DIA / SD</li><li>Le dosage (% ou ratio) -- ex. 07 / 25 / 3 / 8 / 9 / 20</li><li>Si le dosage est réglable ou Fixe -- ex. RE / F ou Si le modèle fait partie d&#39;une ligne -- ex. AL / GL / WL / IL</li><li>Le type de joints présents dans le modèle -- ex. AF / VF / K</li><li>Une autre extension (interne à Dosatron)</li></ul>"
      },
    },
    btn: {
      watch: "Regarder",
      watchVideo: "Regarder la vidéo",
      cancel: "Annuler",
      login: "Connexion",
      download: "Télécharger",
      detail: "Détail",
      allDocuments: "Tous les documents"
    },
    theme: {
      al: "Santé Animale",
      gl: "Irrigation",
      wl: "Traitement de l'eau",
      fl: "Hygiène & agroalimentaire",
      il: "Industrie",
      searchFilters: "Filtres de recherche",
      sectors: "Secteurs",
      search: "Rechercher",
      notClassified: "Non classés",
      filterLanguages: "Filtrer par langues",
      filterMarkets: "Filtrer par marchés",
      filterSectors: "Filtrer par secteurs",
      orientation: "Orientation",
      definition: "Résolution",
      difficuly: "Difficulté",
      viewCount: "Nombre de vues",
      colorMode: "Color Mode",
      colorSpace: "Color Space",
      resolutionUnit: "Unité",
      resolution: "Résolution",
      dimensions: "Dimensions",
      other: "autre",
      others: "{n} autre | {n} autres",
      distributor: "distributeur",
      size: "Poids",
      meta: "Information | Informations",
      date: "Date",
      duration: "Durée",
      documents: "documents",
      document: "document",
      documentCount: "aucun document | {n} document | {n} documents",
      pageCount: "aucune page | {n} page | {n} pages",
      pageCountLabel: "Nombre de pages",
      availableLanguage: "Langue disponible | Langues disponibles",
      availableMarket: "Disponible pour le marché | Disponible pour les marches",
      availableSector: "Disponible pour le secteur | Disponible pour les secteurs",
      availablePack: "Disponible pour le pack | Disponible pour les packs",
      login: {
        username: "Nom d'utilisateur",
        password: "Mot de passe"
      }
    },
    field: {
      required: "Champ obligatoire",
      mailRequired: "Le champ mail est obligatoire",
      mailValid: "Renseigner une adresse mail valide",
    },
    account: {
      profil: "Mon compte",
      logout: "Déconnexion"
    },
    user: {
      login: "Connexion",
      uid: "ID",
      fullname: "Nom complet",
      company: "Société",
      mail: "Mail",
      roles: "Roles",
      language: "Language",
      status: "Status",
      active: "Compte actif",
    },
    headband: {
      search: {
        search: "Recherche",
        placeholder: "Rechercher par référence de doseur ou mot clé‎…",
        helpText: "Où trouver la référence de mon doseur",
        moreFilters: "Plus de critères",
      },
      newsletter: {
        title: "Abonnez-vous à notre newsletter",
        overline: "Recevez les mises à jour et les dernières nouvelles directement de notre équipe. Entrez simplement votre e-mail.",
        placeholder: "Indiquer une adresse email valide",
        messages: {
          success: "Votre adresse mail a été enregistré",
          error: "Une erreur est survenue",
        },
      }
    },
    follow: {
      facebook: "Suivre Dosatron sur Facebook (nouvelle fenêtre)",
      linkedin: "Suivre Dosatron sur Linkedin (nouvelle fenêtre)",
      youtube: "S'abonner à la chaîne Dosatron TV sur Youtube (nouvelle fenêtre)",
      instagram: "Suivre Dosatron sur Instagram (nouvelle fenêtre)",
    }
  }
}
